import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

//Redux
import { useSelector } from "react-redux";
import {
  getTimeFromStringInAmPm,
  getTodaysData,
  validateContactNumber,
  validateName,
  validateRequired,
  validateTextArea,
} from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const PlGateInWardModel = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  let userData = useSelector((state) => state?.user?.data);

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // const [getCustomer, setCustomer] = useState([]);

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  //Load Master Data
  // const getMasterData = async () => {
  //   let obj = {};
  //   await ItemServiceV2.getCustomers(obj).then((item) => {
  //     // console.log(">> item! title", item);
  //     if (item?.status === 200) {
  //       setCustomer(item?.data);
  //     } else {
  //       setCustomer([]);
  //       console.log(">> Error: Loading getCustomers");
  //     }
  //   });
  // };
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "getLogisticsGateEntryList",
  //     module: "CUSTOMER",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //   };
  //   // console.log(obj)
  // };
  const nextHourOptions = [
    { id: 1, name: "1 Hours" },
    { id: 2, name: "2 Hours" },
    { id: 3, name: "3 Hours" },
    { id: 4, name: "4 Hours" },
    { id: 5, name: "5 Hours" },
    { id: 6, name: "6 Hours" },
    { id: 7, name: "7 Hours" },
    { id: 8, name: "8 Hours" },
    { id: 9, name: "9 Hours" },
    { id: 10, name: "10 Hours" },
    { id: 11, name: "11 Hours" },
    { id: 12, name: "12 Hours" },
  ];

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const [formInputs, setFormInputs] = useState({
    gateCode: "",
    inDate: getTodaysData() || "",
    gateInwardSelectedTime: "",
    inNextHour: "",
    inCustomerName: "",
    inVehicleNumber: "",
    inDriverName: "",
    inDriverMobileNumber: "",
    inVehicleType: "",
    inWeightBridge: "",
    inLoadingBay: "",
    inLoadingPoints: "",
    inWeighbridgeName: "",

    gateTransportRequestNumber: "",
    outPass: "",
    gateOutWardDate: "",
    gateOutWardTime: "",
    outRemark: "",
    outNextHour: "",
    outVehicleType: "",
    outWeightBridge: "",
    outVehicleNumber: "",
    outDriverName: "",
    outDriverMobileNumber: "",
    outLoadingBay: "",
    outLoadingPoints: "",
    outWeighbridge: "",
  });

  //getting customer name
  useEffect(() => {
    // getMasterData();

    setFormInputs({
      // createdBy: userData?.userId || "",
      inDate: getTodaysData() || "",
    });
  }, [userData]);

  //Validations
  const [validation, setValidation] = useState({
    inDriverName: "",
  });

  const handleInputChange = ({ target: { name, value } }) => {
    let error = "";

    //Inward Validation
    if (name === "inDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "inDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }
    //OutWard Validations

    if (name === "gateTransportRequestNumber" && !validateRequired(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }
    if (name === "outCustomerName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }

    if (name === "outDriverName" && !validateName(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }
    if (name === "outDriverMobileNumber" && !validateContactNumber(value)) {
      error = message.VALID_CONTACT_NUMBER;
    }

    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const timeOptions = [];

  let id = 1;
  for (let hour = 6; hour <= 24; hour++) {
    for (let min = 0; min < 60; min += 30) {
      const date = new Date();
      date.setHours(hour, min, 0, 0);
      const formattedTime = getTimeFromStringInAmPm(date);
      timeOptions.push({ id: id++, name: formattedTime });
    }
  }

  const gateInWardOutWard = [
    { id: 1, name: "InWard", textField: "gateInwardType" }, //red
    { id: 2, name: "OutWard", textField: "gateInwardType" }, //yellow
  ];

  const typeOfOutpass = [
    { id: 1, name: "Yes" }, //red
    { id: 2, name: "No" }, //yellow
  ];

  useEffect(() => {
    if (!getDropdownData) return;

    // console.log(">>Check getDropdownData Data", getDropdownData);

    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
    }));

    // setSelectedDropdown(getDropdownData?.textField);
  }, [getDropdownData]);

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };
  /* pop failure modal */

  const initialState = {
    gateCode: "",
    inDate: getTodaysData() || "",
    gateInwardSelectedTime: "",
    inNextHour: "",
    inCustomerName: "",
    inVehicleNumber: "",
    inDriverName: "",
    inDriverMobileNumber: "",
    inVehicleType: "",
    inWeightBridge: "",
    inLoadingBay: "",
    inLoadingPoints: "",
    inWeighbridge: "",

    gateTransportRequestNumber: "",
    outPass: "",
    gateOutWardDate: "",
    gateOutWardTime: "",
    outRemark: "",
    outNextHour: "",
    outVehicleType: "",
    outWeightBridge: "",
    outVehicleNumber: "",
    outDriverName: "",
    outDriverMobileNumber: "",
    outLoadingBay: "",
    outLoadingPoints: "",
    outWeighbridge: "",
    outCustomerName:"",
  };
  const handleSave = async () => {
    const requiredFields = [];

    if (formInputs.gate === "InWard") {
      
      if (!validateRequired(formInputs.inCustomerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inCustomerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateName(formInputs.inCustomerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inCustomerName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }
      if (!validateRequired(formInputs.inVehicleNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inVehicleNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.inDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateName(formInputs.inDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }

      if (!validateContactNumber(formInputs.inDriverMobileNumber)) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverMobileNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
      if (!validateRequired(formInputs.inLoadingBay)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inLoadingBay: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.inLoadingPoints)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inLoadingPoints: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.inWeighbridgeName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inWeighbridgeName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    }

    if (formInputs.gate === "OutWard") {
      if (!validateRequired(formInputs.gateTransportRequestNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          gateTransportRequestNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateName(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          inDriverName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }
      if (!validateTextArea(formInputs.outRemark)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outRemark: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateRequired(formInputs.outVehicleNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outVehicleNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (!validateName(formInputs.outDriverName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverName: message.VALID_CUSTOMER_NAME,
        }));
        return;
      }
      if (!validateContactNumber(formInputs.outDriverMobileNumber)) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outDriverMobileNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
      if (!validateRequired(formInputs.outLoadingBay)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outLoadingBay: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outLoadingPoints)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outLoadingPoints: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(formInputs.outWeighbridge)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        setValidation((prev) => ({
          ...prev,
          outWeighbridge: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    }

    // Reset form only after successful validation
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    let obj = {
      data: formInputs,
    };

    // console.log(obj);

    setFormInputs((prev) => ({ ...prev, ...initialState }));
    setDisabled(true);

    await ItemServiceV2.addGateEntry(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        // handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        navigate(LogisticsConstants.LOGISTICS_IN_WORD_OUT_WORD_LIST);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  //Customer drop down

  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
      }));

      //   setCustomerID(getDropdownData?.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Create Gate Entry - Inward/Outward
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={12} md={6} lg={4} className="text-center logoBtn">
                  <span className="iconLogo">GI</span>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <span className="headerTitle">
                    {" "}
                    Gate Entry - Inward/Outward{" "}
                  </span>
                  <span className="subHeaderTitle">
                    Gate Entry - Inward/OutWard Details
                  </span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Gate"
                            placeholder="Select"
                            data={gateInWardOutWard}
                            id="gate"
                            iconClassName="dropdownIcon"
                            name="gate"
                            code="gateCode"
                            description="gateDesc"
                            setValue={formInputs.gate || ""}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.country}
                            // disabled={editMode}
                          />
                        </Col>
                        {formInputs.gate === "InWard" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="date"
                                label="Select Date"
                                name="inDate"
                                id="inDate"
                                value={formInputs?.inDate || ""}
                                onChange={handleInputChange}
                                // disabled={true}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="time"
                                label="Select Time"
                                name="gateInwardSelectedTime"
                                id="gateInwardSelectedTime"
                                value={formInputs?.gateInwardSelectedTime || ""}
                                onChange={handleInputChange}
                                // disabled={true}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Valid for Next"
                                placeholder=""
                                data={nextHourOptions}
                                id="inNextHour"
                                iconClassName="dropdownIcon"
                                name="inNextHour"
                                code="inNextHourCode"
                                description="inNextHourDesc"
                                setValue={formInputs.inNextHour || ""}
                                getvalue={setDropdownData}
                                // getvalue={setDropdownData}
                                // required={true}
                              />
                            </Col>
                            {/* <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Customer Name"
                                placeholder=""
                                data={getCustomer}
                                id="inCustomerName"
                                iconClassName="dropdownIcon"
                                name="inCustomerName"
                                code="inCustomerNameCode"
                                description="inCustomerNameDesc"
                                setValue={formInputs.inCustomerName || ""}
                                getvalue={setDropdownData}
                                required={true}
                              />
                            </Col> */}
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer Name"
                                placeholder=""
                                name="inCustomerName"
                                id="inCustomerName"
                                error={validation?.inCustomerName || ""}
                                value={formInputs?.inCustomerName || ""}
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Vehicle Number"
                                placeholder=""
                                name="inVehicleNumber"
                                id="inVehicleNumber"
                                error={validation.inVehicleNumber || ""}
                                // value={
                                //   formInputs.gateInwardVehicleDetails || ""
                                // }
                                value={formInputs.inVehicleNumber || ""}
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Driver Name"
                                placeholder=""
                                name="inDriverName"
                                id="inDriverName"
                                error={validation?.inDriverName || ""}
                                value={formInputs?.inDriverName || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Driver Contact Nr"
                                placeholder=""
                                name="inDriverMobileNumber"
                                id="inDriverMobileNumber"
                                error={validation.inDriverMobileNumber || ""}
                                value={formInputs.inDriverMobileNumber || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col xs={12} md={6} lg={4}
                            className="commTopButtonRightLeftPadding"
                            >
                              <p>
                                <strong>Please Select Vehicle type</strong>
                              </p>
                              <div className="d-flex fs-5 fw-medium ms-3 my-3">
                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="inVehicleType"
                                      value="emptyVehicle"
                                      checked={
                                        formInputs.inVehicleType ===
                                        "emptyVehicle"
                                      }
                                      onChange={handleInputChange}
                                      id="emptyVehicle"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="emptyVehicle"
                                    >
                                      Empty Vehicle
                                    </label>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="inVehicleType"
                                      value="loadedVehicle"
                                      checked={
                                        formInputs.inVehicleType ===
                                        "loadedVehicle"
                                      }
                                      setValue={formInputs.inVehicleType || ""}
                                      onChange={handleInputChange}
                                      id="loadedVehicle"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="loadedVehicle"
                                    >
                                      Loaded Vehicle
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col xs={12} md={6} lg={4}
                            className="commTopButtonRightLeftPadding"
                            >
                              <p>
                                <strong>
                                  Do you want the Vehicle to proceed to weight
                                  bridge
                                </strong>
                              </p>
                              <div className="d-flex fs-5 fw-medium ms-3 my-3">
                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="inWeightBridge"
                                      value="yes"
                                      checked={
                                        formInputs.inWeightBridge === "yes"
                                      }
                                      onChange={handleInputChange}
                                      id="weighYes"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="weighYes"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="inWeightBridge"
                                      value="no"
                                      checked={
                                        formInputs.inWeightBridge === "no"
                                      }
                                      onChange={handleInputChange}
                                      id="weighNo"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="weighNo"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Loading Bay"
                                placeholder=""
                                name="inLoadingBay"
                                id="inLoadingBay"
                                error={validation.inLoadingBay || ""}
                                value={formInputs.inLoadingBay || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Loading Points"
                                placeholder=""
                                name="inLoadingPoints"
                                id="inLoadingPoints"
                                error={validation.inLoadingPoints || ""}
                                value={formInputs.inLoadingPoints || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Weighbridge"
                                placeholder=""
                                name="inWeighbridgeName"
                                id="inWeighbridgeName"
                                error={validation.inWeighbridgeName || ""}
                                value={formInputs.inWeighbridgeName || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                          </>
                        )}
                        {formInputs.gate === "OutWard" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Transport Request Number"
                                placeholder=""
                                name="gateTransportRequestNumber"
                                id="gateTransportRequestNumber"
                                error={
                                  validation.gateTransportRequestNumber || ""
                                }
                                value={
                                  formInputs.gateTransportRequestNumber || ""
                                }
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Customer Name"
                                placeholder=""
                                name="outCustomerName"
                                id="outCustomerName"
                                error={validation?.outCustomerName || ""}
                                value={formInputs?.outCustomerName || ""}
                                onChange={handleInputChange}
                                required={true}
                                
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Type Of Outpass"
                                placeholder=""
                                data={typeOfOutpass}
                                id="outPass"
                                iconClassName="dropdownIcon"
                                name="outPass"
                                code="outPass"
                                description="outPass"
                                setValue={formInputs.outPass || ""}
                                getvalue={setDropdownData}
                                // getvalue={setDropdownData}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="date"
                                label="Select Date"
                                name="outDate"
                                id="outDate"
                                value={formInputs?.outDate}
                                onChange={handleInputChange}
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="time"
                                label="Select Time"
                                name="gateOutWardTime"
                                id="gateOutWardTime"
                                value={formInputs?.gateOutWardTime}
                                onChange={handleInputChange}
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Enter Gate Remarks"
                                name="outRemark"
                                id="outRemark"
                                value={formInputs.outRemark}
                                error={validation.outRemark || ""}
                                onChange={handleInputChange}
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Valid for Next"
                                placeholder="Choose Hours"
                                data={nextHourOptions}
                                id="outNextHour"
                                iconClassName="dropdownIcon"
                                name="outNextHour"
                                code="outNextHour"
                                description="outNextHour"
                                setValue={formInputs.outNextHour || ""}
                                getvalue={setDropdownData}

                                // required={true}
                              />
                            </Col>
                            <Col xs={12} md={6} lg={4}
                            className="commTopButtonRightLeftPadding"
                            >
                              <p>
                                <strong>Please Select Vehicle type</strong>
                              </p>
                              <div className="d-flex fs-5 fw-medium ms-3 my-3">
                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="outVehicleType"
                                      value="emptyVehicle"
                                      checked={
                                        formInputs.outVehicleType ===
                                        "emptyVehicle"
                                      }
                                      onChange={handleInputChange}
                                      id="emptyVehicle"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="emptyVehicle"
                                    >
                                      Empty Vehicle
                                    </label>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="outVehicleType"
                                      value="loadedVehicle"
                                      checked={
                                        formInputs.outVehicleType ===
                                        "loadedVehicle"
                                      }
                                      setValue={formInputs.outVehicleType || ""}
                                      onChange={handleInputChange}
                                      id="loadedVehicle"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="loadedVehicle"
                                    >
                                      Loaded Vehicle
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col xs={12} md={6} lg={4}
                            className="commTopButtonRightLeftPadding"
                            >
                              <p>
                                <strong>
                                  Do you want the Vehicle to proceed to weight
                                  bridge
                                </strong>
                              </p>
                              <div className="d-flex fs-5 fw-medium ms-3 my-3">
                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="outWeightBridge"
                                      value="yes"
                                      checked={
                                        formInputs.outWeightBridge === "yes"
                                      }
                                      onChange={handleInputChange}
                                      id="weighYes"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="weighYes"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center me-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input me-2"
                                      type="radio"
                                      name="outWeightBridge"
                                      value="no"
                                      checked={
                                        formInputs.outWeightBridge === "no"
                                      }
                                      onChange={handleInputChange}
                                      id="weighNo"
                                    />
                                    <label
                                      className="form-check-label fs-5"
                                      htmlFor="weighNo"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Vehicle Number"
                                placeholder=""
                                name="outVehicleNumber"
                                id="outVehicleNumber"
                                error={validation.outVehicleNumber || ""}
                                // value={
                                //   formInputs.outVehicleNumber || ""
                                // }
                                value={formInputs.outVehicleNumber || ""}
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Driver Name"
                                placeholder=""
                                name="outDriverName"
                                id="outDriverName"
                                error={validation.outDriverName || ""}
                                value={formInputs?.outDriverName || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Enter Driver Contact Nr"
                                placeholder=""
                                name="outDriverMobileNumber"
                                id="outDriverMobileNumber"
                                error={validation.outDriverMobileNumber || ""}
                                value={formInputs?.outDriverMobileNumber || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Loading Bay"
                                placeholder=""
                                name="outLoadingBay"
                                id="outLoadingBay"
                                error={validation.outLoadingBay || ""}
                                value={formInputs?.outLoadingBay || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Loading Points"
                                placeholder=""
                                name="outLoadingPoints"
                                id="outLoadingPoints"
                                error={validation.outLoadingPoints || ""}
                                value={formInputs?.outLoadingPoints || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Weighbridge"
                                placeholder=""
                                name="outWeighbridge"
                                id="outWeighbridge"
                                error={validation.outWeighbridge || ""}
                                value={formInputs?.outWeighbridge || ""}
                                onChange={handleInputChange}
                                // required={true}
                              />
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
      </Modal.Body>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </Modal>
  );
});

export default PlGateInWardModel;
